

export class HolidayDto implements IHolidayDto {
    id!: number;
    holidayName!: string | undefined;
    isActive!: boolean;

    constructor(data?: IHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.holidayName = _data["holidayName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["holidayName"] = this.holidayName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IHolidayDto {
    id: number;
    holidayName: string | undefined;
    isActive: boolean;
}

